import ManagedGridView from "../controls/ManagedGridView";
import { SearchQuery } from "../code/search-query/search-query";
import {
  companyPermissionsViewColumns,
  companyPermissionsSearchSchema,
  mapCompanyPermissionsViewQuery,
} from "./CompanyPermissionsView.default";
import { getCompanyRolesPermissions } from "../repository/data.repository";
import { createGridRequest } from "../hooks/useGridRequest";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";

export interface CompanyPermissionsViewProps {
  readonly trigger?: string;
  readonly onAction?: (key: string, record: any) => void;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

function CompanyPermissionsView(props: CompanyPermissionsViewProps) {
  const permissions = useSelector(authorizeSelectors.permissions);
  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={companyPermissionsViewColumns}
      schema={companyPermissionsSearchSchema}
      mapQuery={mapCompanyPermissionsViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getCompanyRolesPermissions, { retry: true })}
      pageSize={100}
      actions={[
        {
          key: "update",
          label: "Edit",
          disabled: !permissions.can("CompanyRolesPermissions", "edit"),
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "delete",
          label: "Delete",
          danger: true,
          disabled: !permissions.can("CompanyRolesPermissions", "delete"),
          handler: (key, record) => props.onAction?.(key, record),
        },
      ]}
    />
  );
}

export default CompanyPermissionsView;
